<template>

  <div class="grid-content bg-purple treeContent">
    <!--<el-col :span="16">-->
    <!--<el-input style="width:200px;"-->
    <!--placeholder="请输入仓库编码或名称查询"-->
    <!--prefix-icon="el-icon-search"-->
    <!--v-model="searchexternaldata">-->
    <!--</el-input>-->
    <!--</el-col>-->
    <!--<el-col :span="8">-->
    <!--<el-button type="primary" icon="el-icon-search" @click="bindExternalGrid">搜索</el-button>-->
    <!--</el-col>-->

    <el-table
      :data="tableDataExternal"
      ref="moviesTable"
      size="mini"
      stripe
      style="width: 100%;"
      :show-header="false"
      @selection-change="handleSelectionChange"
    >

      <el-table-column
        type="selection"
        width="30"

      >

      </el-table-column>

      <el-table-column label="仓库名称" align="left" font-size="18px">
        <template slot-scope="scope">
               <span style="cursor: pointer;" @click="handleExternalClick(scope.$index, scope.row)">
               {{scope.row.cangkuname}}</span>
        </template>
      </el-table-column>
    </el-table>


    <!--<div class="foot" >-->
    <!--<Pagination ref="pagination1" :layout="'prev, pager, next'" :pagerCount="5" @bindgrid="bindExternalGrid"-->
    <!--:pagination="paginationExternal"></Pagination>-->
    <!--</div>-->
  </div>


</template>

<script>
  import {getListData, deleteData} from '@/api/set/jxcstore'
  import {getListData as getExternalListData} from '@/api/set/jxcstore';

  export default {
    name: 'JxcstoreListView',
    msg:'盘点单左侧仓库选择页面',
    data() {
      return {
        cangkucode: "",
        cangkuname: "",
        unitguid: "",
        searchexternaldata: '',
        isch: 0,

        loading: true,
        paginationExternal: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        tableDataExternal: [],
        multipleSelection: [],
        cangkucodes: [],
        controlData: {}
      }
    },
    props: {
      canMultySelect: {//是否可以多选
        default: true
      }
    },
    methods: {


      handleExternalClick(index, row) {
        this.cangkucodes = [],
          this.cangkucodes.push(row.cangkucode)
        this.cangkucode = row.cangkucode
        this.cangkuname = row.cangkuname
        this.unitguid = row.unitguid
        if (row) {
          for (var i = 0; i < this.tableDataExternal.length; i++) {
            this.$refs.moviesTable.toggleRowSelection(this.tableDataExternal[i], false)
          }
          this.$refs.moviesTable.toggleRowSelection(row, true)
        } else {
          this.cangkucodes.push(this.tableDataExternal[0].cangkucode)
        }

        this.$emit("select", this.cangkucodes, this.cangkuname)
      },

      bindExternalGrid() {//绑定工厂
        getExternalListData({
          offset: (this.paginationExternal.currentPage - 1) * this.paginationExternal.pageSize,
          limit: this.paginationExternal.pageSize,
          cangkuname: this.searchexternaldata,
          unitgroup: this.unitgroup,
        }).then(response => {
          this.tableDataExternal = response.data.obj.rows
          this.paginationExternal.total = response.data.obj.total
          if (this.tableDataExternal) {
            this.cangkucodes.push(this.tableDataExternal[0].cangkucode)
            this.$emit("select", this.cangkucodes, this.cangkuname, this.unitguid)
            this.checked(this.tableDataExternal[0])

          }

        }).catch((error) => {
          console.log(error)
        });
      },


      handleSelectionChange(val) {


        this.cangkucodes = [];
        if (val.length == 1) {
          this.cangkuname = val[0].cangkuname
        } else {
          this.cangkuname = ''
        }

        if (!this.canMultySelect) {
          if (val && val.length > 0) {
            for (var i = 0; i < val.length - 1; i++) {
              this.$refs.moviesTable.toggleRowSelection(val[i], false)
            }
            this.cangkucodes = []
            this.cangkucodes.push(val[val.length - 1].cangkucode)
          }
        } else {
          for (var i = 0; i < val.length; i++) {
            this.cangkucodes.push(val[i].cangkucode)
          }
        }


        // else {
        //   this.$refs.moviesTable.toggleRowSelection(this.tableDataExternal[0],true)
        //   this.cangkuname=this.tableDataExternal[0].cangkuname
        //   this.cangkucodes.push(this.tableDataExternal[0].cangkucode)
        // }
        this.$emit("select", this.cangkucodes, this.cangkuname, this.unitguid)
      },

      checked(row) {
        this.$nextTick(() => {
          this.$refs.moviesTable.toggleRowSelection(row, true)
        })

      },

    },
    mounted() {
      this.bindExternalGrid()

    },
    components: {}

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/warehouse/JxcstoreListView.vue